/* global localStorage */
import Store from 'store/store'
import dot from 'dot-prop'

const NS = `${window.ENV.name}@${window.ENV.version}/${window.location.pathname}__`
const DEFAULT = {
  read: data => JSON.parse(data),
  write: data => JSON.stringify(data),
  silent: false
}

const WRITE_ONLY = {
  read: data => null,
  write: data => JSON.stringify(data)
}

export const KEYS = {
  formats: DEFAULT,
  regions: DEFAULT,
  'text.h1': DEFAULT,
  'text.h2': DEFAULT,
  'text.h3': DEFAULT,
  'text.h4': DEFAULT,
  'text.h5': DEFAULT,
  'text.h6': DEFAULT,
  'steps.lastReached': DEFAULT,
  // Order is important so that the Landscape.swatch is already restored when
  // seed restoration triggers the Landscape.abstraction
  'landscape.colors': DEFAULT,
  'landscape.seed': DEFAULT
}

export default {
  exists: !!localStorage.getItem(NS + 'steps.lastReached') >= 1,

  clear: () => {
    Object.entries(KEYS).forEach(([key]) => {
      localStorage.removeItem(NS + key)
    })
  },

  store: () => {
    Object.entries(KEYS).forEach(([key, { write }]) => {
      const signal = dot.get(Store, key)
      if (!signal) return

      const value = signal.get()
      localStorage.setItem(NS + key, write(value))
    })
  },

  register: () => {
    Object.entries(KEYS).forEach(([key, { write, silent }]) => {
      const signal = dot.get(Store, key)
      if (!signal) return

      signal.subscribe(value => {
        Store.app.isSaving.set(true)
        localStorage.setItem(NS + key, write(value))
        Store.app.isSaving.set(false)
      })
    })
  },

  restore: () => {
    Object.entries(KEYS).forEach(([key, { read, silent }]) => {
      const signal = dot.get(Store, key)
      if (!signal) return

      const value = read(localStorage.getItem(NS + key))
      if (value === null) return

      if (silent) signal.current = value
      else signal.set(value)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/local-storage.js